<template>
    <div class="text-sm text-base-content-subtle">
        {{ translatedGender }}
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    gender: string
}>()

const { t } = useI18n()

const translatedGender = computed(() => {
    const genderKey = `product.gender.${props.gender}`
    return t(genderKey)
})
</script>
